// extracted by mini-css-extract-plugin
module.exports = {"bg_verde":"Style_bg_verde__12UVg","bg_amarillo":"Style_bg_amarillo__2qvxB","bg_rojo":"Style_bg_rojo__1tDrH"};